import { transport } from 'config/transport';

export function callApiExportNoiTruMonthlyReport(congDoanId, yearMonth, pdf = false) {
    return transport.get(`/noitru/${congDoanId}/thuchi/exportReport`, { params: { yearMonth, pdf }, responseType: 'blob' });
}
